import { render, staticRenderFns } from "./VProductShare.vue?vue&type=template&id=e9a71c6e&scoped=true&"
import script from "./VProductShare.vue?vue&type=script&lang=ts&"
export * from "./VProductShare.vue?vue&type=script&lang=ts&"
import style0 from "./VProductShare.vue?vue&type=style&index=0&id=e9a71c6e&lang=scss&scoped=true&"
import style1 from "./VProductShare.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e9a71c6e",
  null
  
)

export default component.exports